import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root',
})
export class CryptoService {
  decryptPassword(password: string, apiKey: string): string {
    const key = CryptoJS.enc.Utf8.parse(apiKey);
    // Decrypt the password using AES decryption
    const decrypted = CryptoJS.AES.decrypt(password, key, {
      mode: CryptoJS.mode.ECB,
    }).toString(CryptoJS.enc.Utf8);
    return decrypted;
  }
}
